import { type ExtensionContributionAttributes } from './generated/ExtensionContributionAttributes';
import { model } from '../modelBuilder';
import ApplicationModel, { attr } from '../ApplicationModel';

interface ExtensionContribution extends ExtensionContributionAttributes {}

@model
class ExtensionContribution extends ApplicationModel {
  // Start auto-generated
  static typename: 'ExtensionContribution' = 'ExtensionContribution';
  get typename(): 'ExtensionContribution' {
    return 'ExtensionContribution';
  }

  static internalTypename: 'ExtensionContribution' = 'ExtensionContribution';
  get internalTypename(): 'ExtensionContribution' {
    return 'ExtensionContribution';
  }

  static filterType = 'ExtensionContributionFilters!';
  static filters = {
    id: '[ID!]',
    identifier: 'String',
    contributes: 'String',
    includeDisabled: 'Boolean',
  };

  static fields = {
    createdAt: attr({ readable: true }),
    endpoint: attr({ readable: true }),
    id: attr({ readable: true }),
    identifier: attr({ readable: true }),
    name: attr({ readable: true }),
    updatedAt: attr({ readable: true }),
    extension: attr.belongsTo({ readable: true, typename: 'Extension' }),
    permissions: attr.belongsTo({
      readable: true,
      typename: 'ResourcePermissions',
    }),
  };
  // End auto-generated

  get exportName() {
    return this.identifier?.split('.').slice(-1)[0] ?? null;
  }
}

export default ExtensionContribution;
